import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {FormPageComponent} from '../../../components/form-page/form-page.component';
import {Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {ButtonDirective} from 'primeng/button';
import {AsyncPipe} from '@angular/common';
import {ProgressSpinner} from 'primeng/progressspinner';
import {AnalyticsService} from '../../../services/analytics.service';
import {PaymentService} from '../../../services/payment/payment.service';
import {ActivatedRoute} from '@angular/router';
import typia from "typia";

@Component({
  selector: 'homey-resubscribe-payment-success-page',
  standalone: true,
  imports: [
    FormPageComponent,
    ButtonDirective,
    AsyncPipe,
    ProgressSpinner,
  ],
  templateUrl: './resubscribe-payment-success-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResubscribePaymentSuccessPageComponent {
  protected readonly completed$ = this.userService.waitUntilPaymentStatusPaid();
  private readonly analyticsService = inject(AnalyticsService);
  private readonly paymentService = inject(PaymentService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly isInterval = typia.createIs<'annual' | 'monthly'>();

  constructor(private readonly userService: UserService) {
    const intervalFromQuery = this.route.snapshot.queryParamMap.get('interval');
    const interval = this.isInterval(intervalFromQuery) ? intervalFromQuery : 'unknown';
    void this.analyticsService.sendPaymentSuccess({
      flow: 'resubscribe',
      checkoutLocation: 'default',
      interval,
      amount: 15,
    });
  }

  protected readonly user = this.userService.user;

  protected readonly onContinue = async () => {
    await this.paymentService.runAutoApplyAfterResubscribe();
    void this.router.navigateByUrl('/');
  };
}
